import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'kt-toll-fee-popup',
  templateUrl: './toll-fee-popup.component.html',
  styleUrls: ['./toll-fee-popup.component.scss']
})
export class TollFeePopupComponent implements OnInit {
  public data: any;
  public class: string;

  constructor() { }

  ngOnInit() {
  }

}
